import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { Badge, SxProps } from '@mui/material';

interface TabItem {
    value: string;
    label: string;
    hideTab?: boolean;
    badgeContent?: number;
    sx?: SxProps;
}

interface TabProp {
    setTabValue: (value: any) => void;
    tabs: TabItem[];
    tabValue: string;
}
const TAB_FONT_COLOR = '#202A44';
export default function ColorTabs({ tabValue, setTabValue, tabs }: TabProp) {
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setTabValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Tabs
                value={tabValue}
                onChange={handleChange}
                sx={{
                    '& .MuiTabs-indicator': {
                        backgroundColor: TAB_FONT_COLOR,
                    },
                    '& .MuiTab-root': {
                        textTransform: 'capitalize',
                    },
                    '& .MuiTab-textColorPrimary': {
                        color: TAB_FONT_COLOR, // selected tabs
                    },
                    '& .MuiTab-root.MuiTab-textColorPrimary:not(.Mui-selected)': {
                        color: '#9CA3AF', // Change this to the color you want for non-selected tabs
                    },
                }}
                TabIndicatorProps={{ color: 'red' }}
                aria-label="secondary tabs example"
                variant="scrollable"
                scrollButtons={false}
            >
                {tabs.map((tab) => {
                    const { value, label, badgeContent, ...rest } = tab || {};
                    return (
                        <Tab
                            icon={<Badge badgeContent={badgeContent} color="secondary" />}
                            iconPosition="end"
                            key={value}
                            value={value}
                            label={label}
                            style={{ color: value === tabValue ? TAB_FONT_COLOR : 'gray' }}
                            {...rest}
                        />
                    );
                })}
            </Tabs>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}></div>
        </Box>
    );
}
